export const mergeMapByKey = <T, V>(
  data: Array<T> | Map<V, T>,
  source: Map<V, T>,
  key: keyof T
): Map<V, T> => {
  const dataArray = !Array.isArray(data) ? Array.from(data.values()) : data
  const sourceArray = Array.from(source.values())

  return new Map(
    [...dataArray, ...sourceArray].map((item) => [item[key] as V, item])
  )
}
